<template>
  <div>
    <b-modal
      id="modal-add-detail-daily"
      size="md"
      title="กรุณากรอกปริมาณการใช้งาน"
      ok-title="Save"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
    >
      <template #modal-header="{}">
        <h5 class="fw-semibold" style="font-size: 1.1em">
          กรุณากรอกปริมาณการใช้งาน
        </h5>
        <h5 @click="closeModal()" class="ms-auto" style="font-size: 1.5rem">
          x
        </h5>
      </template>
      <div class="row pb-3">
        <div class="mt-1">
          <div class="box-header">
            <div>
              {{
                `${
                  measureById && measureById.category
                    ? measureById.category.name
                    : ""
                } / ${
                  measureById && measureById.item ? measureById.item.name : ""
                }`
              }}
            </div>
            <div style="font-size: 10px">
              {{
                `${
                  measureById && measureById.company
                    ? measureById.company.name_en
                    : ""
                } / ${
                  measureById && measureById.branch
                    ? measureById.branch.name
                    : ""
                } / ${
                  measureById && measureById.building
                    ? measureById.building.name
                    : ""
                }`
              }}
            </div>
          </div>
        </div>
        <div class="mt-1">
          <label class="fw-bold mb-1 label-text">วันที่ของข้อมูล *</label>
          <DatePicker
            v-model="form.datePicker"
            placeholder="วันที่ของข้อมูล"
            class="w-100 text-sub-header text-center"
            :formatter="setFormatDateTime()"
            type="month"
            :disabled-date="dupilcateMonth"
          />
          <span
            v-if="
              validationStatus == false &&
              v$.form.datePicker &&
              v$.form.datePicker.required &&
              v$.form.datePicker.required.$invalid
            "
            class="error-text"
            >กรุณาเลือกวันที่ของข้อมูล
          </span>
        </div>
        <div
          v-if="measureById && measureById.item && measureById.item.format == 3"
          class="mt-1"
        >
          <label class="fw-bold mb-1 label-text"
            >ชนิดของระบบบำบัดน้ำเสีย *</label
          >
          <select
            v-model="form.type_of_waste_water"
            class="form-select form-select-sm"
            aria-label=".form-select-sm example"
          >
            <option value="1">ระบบเดียว</option>
            <option value="2">หลายระบบ</option>
          </select>
        </div>
        <div
          v-if="measureById && measureById.item && measureById.item.format == 3"
          class="mt-1"
        >
          <label class="fw-bold mb-1 label-text">ค่าการรายงานน้ำ *</label>
          <select
            v-model="form.water_reporting"
            class="form-select form-select-sm"
            aria-label=".form-select-sm example"
          >
            <option value="1">BOD</option>
            <option value="2">COD</option>
          </select>
        </div>
        <div
          v-if="measureById && measureById.item && measureById.item.format == 3"
          class="mt-1"
        >
          <label class="fw-bold mb-1 label-text">{{
            form.type_of_waste_water == 1
              ? `ค่า ${form.water_reporting == 1 ? "BOD" : "COD"} *`
              : `ค่า ${form.water_reporting == 1 ? "BOD" : "COD"} ท่อน้ำเข้า *`
          }}</label>
          <b-input-group append="mg / L">
            <b-form-input
              v-model="form.bod_water_inlet"
              id="bod_water_inlet"
              type="text"
              :placeholder="`${
                form.type_of_waste_water == 1
                  ? `ค่า ${form.water_reporting == 1 ? 'BOD' : 'COD'} *`
                  : `ค่า ${
                      form.water_reporting == 1 ? 'BOD' : 'COD'
                    } ท่อน้ำเข้า *`
              }`"
              class="text-start"
              @keypress="numberOnly"
            ></b-form-input>
          </b-input-group>
          <span
            v-if="
              validationStatus == false &&
              v$.form.bod_water_inlet &&
              v$.form.bod_water_inlet.required &&
              v$.form.bod_water_inlet.required.$invalid
            "
            class="error-text"
          >
            กรุณากรอกค่า
            {{ form.water_reporting == 1 ? "BOD" : "COD" }} ขาน้ำเข้า
          </span>
        </div>
        <div
          v-if="
            measureById &&
            measureById.item &&
            measureById.item.format == 3 &&
            form.type_of_waste_water == 2
          "
          class="mt-1"
        >
          <label class="fw-bold mb-1 label-text"
            >ค่า {{ form.water_reporting == 1 ? "BOD" : "COD" }} ท่อน้ำออก
            *</label
          >
          <b-input-group append="mg / L">
            <b-form-input
              v-model="form.bod_water_outlet"
              id="bod_water_outlet"
              type="text"
              :placeholder="`ค่า ${
                form.water_reporting == 1 ? 'BOD' : 'COD'
              } ขาน้ำออก`"
              class="text-start"
              @keypress="numberOnly"
            ></b-form-input>
          </b-input-group>
          <span
            v-if="
              validationStatus == false &&
              v$.form.bod_water_outlet &&
              v$.form.bod_water_outlet.required &&
              v$.form.bod_water_outlet.required.$invalid
            "
            class="error-text"
            >กรุณากรอกค่า
            {{ form.water_reporting == 1 ? "BOD" : "COD" }} ขาน้ำออก
          </span>
        </div>
        <div
          v-if="measureById && measureById.item && measureById.item.format == 3"
          class="mt-1"
        >
          <label class="fw-bold mb-1 label-text">ปริมาณน้ำ *</label>
          <b-input-group append="L">
            <b-form-input
              v-model="form.water_quantity"
              id="water_quantity"
              type="text"
              placeholder="โปรดระบุปริมาณ"
              class="text-start"
              @keypress="numberOnly"
            ></b-form-input>
          </b-input-group>
          <span
            v-if="
              validationStatus == false &&
              v$.form.water_quantity &&
              v$.form.water_quantity.required &&
              v$.form.water_quantity.required.$invalid
            "
            class="error-text"
            >กรุณากรอกปริมาณ
          </span>
        </div>
        <div
          v-if="measureById && measureById.item && measureById.item.format == 2"
        >
          <div class="mt-1">
            <label class="fw-bold mb-1 label-text">จำนวนพนักงาน *</label>
            <b-input-group append="คน">
              <b-form-input
                v-model="form.number_of_employee"
                id="amount"
                type="text"
                placeholder="โปรดระบุจำนวนพนักงาน"
                class="text-start"
                @input="form.amount = checkFormatValue($event)"
                @keypress="numberOnly"
              ></b-form-input>
            </b-input-group>
          </div>

          <div class="mt-1">
            <label class="fw-bold mb-1 label-text">วันทำงานของพนักงาน *</label>
            <b-input-group append="วัน">
              <b-form-input
                v-model="form.quantity"
                id="amount"
                type="text"
                placeholder="โปรดระบุ วันทำงานของพนักงาน"
                class="text-start"
                @input="form.amount = checkFormatValue($event)"
                @keypress="numberOnly"
              ></b-form-input>
            </b-input-group>
          </div>
        </div>
        <div
          v-if="measureById && measureById.item && measureById.item.format == 1"
        >
          <label class="fw-bold mb-1 label-text">ปริมาณ *</label>
          <b-input-group
            :append="measureById.unit ? measureById.unit.name_en : ''"
          >
            <b-form-input
              v-model="form.amount"
              id="amount"
              type="text"
              placeholder="ปริมาณ"
              class="text-start"
              @input="form.amount = checkFormatValue($event)"
              @keypress="numberOnly"
            ></b-form-input>
          </b-input-group>
          <!-- <b-form-input
            v-model="form.amount"
            id="amount"
            type="text"
            placeholder="ปริมาณ"
            class="text-start"
            @input="form.amount = checkFormatValue($event)"
            @keypress="numberOnly"
          ></b-form-input> -->

          <span
            v-if="
              validationStatus == false &&
              v$.form.amount &&
              v$.form.amount.required &&
              v$.form.amount.required.$invalid
            "
            class="error-text"
            >กรุณากรอกยอดใช้งาน
          </span>
          <!-- <p v-if="typeof form.amount == 'number'" class="mb-0">
            Note : {{ form.amount ? form.amount.toLocaleString("en-US") : 0 }}
            {{ unit }}
          </p>
          <p v-else>
            {{ form.amount ? form.amount.toLocaleString("en-US") : 0 }}
            {{ unit }}
          </p> -->

          <!-- <div
            v-if="$route.query.input_type != 0"
            class="d-flex align-items-center justify-content-center"
          >
            <input
              v-model="is_reset_meter"
              class="form-check-input mt-0 ms-auto"
              type="checkbox"
              style="margin-right: 10px"
            />
            <span>รีเซ็ตมิเตอร์</span>
          </div>
          <b-form-input
            v-if="is_reset_meter"
            v-model="form.balance_before_reset"
            id="amount"
            type="text"
            placeholder="ยอดก่อนรีเซ็ต"
            class="text-center mt-2"
            @input="form.balance_before_reset = checkFormatValue($event)"
            @keypress="numberOnly"
            required
          ></b-form-input>
          <span
            v-if="
              validationStatus == false &&
              v$.form.balance_before_reset &&
              v$.form.balance_before_reset.required &&
              v$.form.balance_before_reset.required.$invalid
            "
            class="error-text"
            >กรุณากรอกยอดก่อนรีเซ็ต
          </span> -->
        </div>

        <div class="mt-3">
          <button
            class="btn border w-100 button-upload"
            @click="showModalAttachFile()"
          >
            <i class="fa fa-upload pe-1" aria-hidden="true"></i>
            <span v-if="fileName">{{ fileName }}</span>
            <span v-else>แนบเอกสารอ้างอิง</span>
          </button>
        </div>
      </div>
      
      <template #modal-footer="{}">
        <div class="d-flex justify-content-center w-100">
          <!-- <button class="btn button-green px-5" @click="confirmCreateFillin()">
            บันทึก
          </button> -->
          <BtnSubmit @onSubmitBtn="confirmCreateFillin" />
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import helper from "../../mixins/helper";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import DatePicker from "vue2-datepicker";
import BtnSubmit from "@/components/BtnSubmit";
import "vue2-datepicker/index.css";
export default {
  // props : ['nextDate'],
  components: {
    DatePicker,
    BtnSubmit,
  },
  setup: () => ({ v$: useVuelidate() }),
  mixins: [helper],
  props: {
    nextDate: {
      default: null,
    },
    resetForm: {
      type: Boolean,
      default: false,
    },
    typeModal: {
      type: String,
      default: null,
    },
    typeName: {
      type: String,
      default: null,
    },
    fileName: {
      type: [String, File],
      default: null,
    },
    dataEditDaily: {
      type: [Array, Object],
      default: null,
    },
    timeNow: {
      type: String,
      default: null,
    },
    minDate: {
      type: String,
      default: null,
    },
    maxDate: {
      type: String,
      default: null,
    },
    unit: {
      type: String,
      default: null,
    },
    dateTime: {},
    measureById: {},
  },
  data() {
    return {
      form: {
        datetime: "",
        amount: null,
        balance_before_reset: null,
        timePicker: null,
        datePicker: null,
        number_of_employee: null,
        quantity: null,
        water_reporting: 2,
        type_of_waste_water: 1,
        bod_water_inlet: null,
        bod_water_outlet: null,
        water_quantity: null,
      },
      is_reset_meter: false,
      validationStatus: true,
    };
  },
  validations() {
    if (
      this.measureById &&
      this.measureById.item &&
      this.measureById.item.format == 2
    ) {
      return {
        form: {
          datePicker: { required },
          number_of_employee: { required },
          quantity: { required },
        },
      };
    } else if (
      this.measureById &&
      this.measureById.item &&
      this.measureById.item.format == 1
    ) {
      return {
        form: {
          datePicker: { required },
          amount: { required },
        },
      };
    } else {
      if (this.form.type_of_waste_water == 1) {
        return {
          form: {
            datePicker: { required },
            water_reporting: { required },
            type_of_waste_water: { required },
            bod_water_inlet: { required },
            water_quantity: { required },
          },
        };
      } else {
        return {
          form: {
            datePicker: { required },
            water_reporting: { required },
            type_of_waste_water: { required },
            bod_water_inlet: { required },
            bod_water_outlet: { required },
            water_quantity: { required },
          },
        };
      }
    }
  },
  watch: {
    resetForm: "resetFormData",
    nextDate: "setDateNextDay",
    dataEditDaily: "setDataEditDaily",
    timeNow: "setTimeNow",
  },
  methods: {
    checkFormatValue(value) {
      let new_value = value;
      // console.log(new_value);
      if (new_value) {
        if (isNaN(new_value)) {
          new_value = parseFloat(new_value.replace(/,/g, "")).toLocaleString(
            "en-US"
          );
        } else {
          new_value = parseFloat(new_value).toLocaleString("en-US");
        }
      }
      return new_value;
    },
    closeModal() {
      this.$bvModal.hide("modal-add-detail-daily");
      this.resetModal();
    },
    resetFormData() {
      if (this.resetForm == true) {
        this.form.datetime = "";
        this.form.datePicker = "";
        this.form.amount = "";
        this.form.balance_before_reset = null;
        this.is_reset_meter = false;
        this.validationStatus = true;
        this.form.number_of_employee = null;
        this.form.quantity = null;
        this.form.water_reporting = 2;
        this.form.type_of_waste_water = 1;
        this.form.bod_water_inlet = null;
        this.form.bod_water_outlet = null;
        this.form.water_quantity = null;
      }
    },
    setDateNextDay(next_period) {
      if (next_period && next_period._d) {
        // this.form.datePicker = next_period;
        this.form.datePicker = next_period._d;
      } else {
        this.form.datePicker = next_period;
      }
      // this.form.datetime = date;
    },
    resetModal() {
      this.form.datetime = "";
      this.form.amount = "";
      this.form.balance_before_reset = null;
      this.is_reset_meter = false;
      this.validationStatus = true;
      this.form.datePicker = "";
      this.form.number_of_employee = null;
      this.form.quantity = null;
      this.form.water_reporting = 2;
      this.form.type_of_waste_water = 1;
      this.form.bod_water_inlet = null;
      this.form.bod_water_outlet = null;
      this.form.water_quantity = null;
    },
    async confirmCreateFillin() {
      let isValidate = await this.v$.$validate();
      if (isValidate) {
        if (this.typeModal == "create") {
          this.$emit("saveDataDaily", this.form);
        } else {
          this.$emit("editDataDaily", this.form);
        }
      } else {
        this.validationStatus = false;
      }
    },
    showModalAttachFile() {
      this.$emit("showModalAttachReference");
    },
    setDataEditDaily(data) {
      if (
        this.measureById &&
        this.measureById.item &&
        this.measureById.item.format == 2
      ) {
        this.form.datePicker = data.date ? new Date(data.date) : null;
        this.form.number_of_employee = data.amount.toLocaleString("en-US");
        this.form.quantity = data.quantity.toLocaleString("en-US");
      } else if (
        this.measureById &&
        this.measureById.item &&
        this.measureById.item.format == 1
      ) {
        // this.form.amount = data.amount.toString();
        this.form.amount = data.amount.toLocaleString("en-US");
        this.form.datePicker = data.date ? new Date(data.date) : null;
      } else {
        console.log('daata',data)
        this.form = {
          datePicker : data.date ? new Date(data.date) : null,
          water_reporting: data.water_report,
          type_of_waste_water: data.wastewater_treatment_system_type,
          bod_water_inlet: data.amount_of_entry.toLocaleString("en-US"),
          bod_water_outlet: data.amount_of_out.toLocaleString("en-US"),
          amount: data.amount.toLocaleString("en-US"),
          water_quantity : data.amount.toLocaleString("en-US"),
        };
      }
    },
    setTimeNow(time) {
      this.form.timePicker = time;
    },
    dupilcateMonth(date) {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();

      // Extract year and month from the date to be checked
      const yearToCheck = date.getFullYear();
      const monthToCheck = date.getMonth();

      // Disable future months (months occurring after the current month and year)
      if (
        yearToCheck > currentYear ||
        (yearToCheck === currentYear && monthToCheck > currentMonth)
      ) {
        return true; // Disable the date if it's a future month
      }

      if (this.dateTime && this.dateTime.length > 0) {
        for (const { year, months } of this.dateTime) {
          if (date.getFullYear() === year && months.includes(date.getMonth())) {
            return true;
          }
        }
      }

      return false;
    },
  },
};
</script>
<style lang="scss">
.form-check-input:checked {
  background: #68b281;
  border-color: #68b281;
}

.box-header {
  border-radius: 8px;
  background: rgba(104, 178, 129, 0.1);
  padding: 8px;
  color: #51646b;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
